import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class TranslateProvider {

	constructor(
		private translateService: TranslateService
	) {

	}

	public getTranslateKey(key) {
		return this.translateService.instant(key);
	}

}



// WEBPACK FOOTER //
// ./src/providers/translate/translate.ts